import { useEffect, useRef, useState } from "react";
import nextCookie from "next-cookies";
import Router from "next/router";
import Head from "next/head";

import { brandsApi } from "../../services/api";

import { souvApi } from "../../services/api";
import { Form, FormButton, FormButtonSouv } from "../../styles/form"
import InputMask from 'react-input-mask';
import cookie from "js-cookie";
import CTA from "../CTA";
import Layout from "../LayoutCardapio";
import { SouvenirCheck } from "../SouvPage/styles";
import Container from "../Container";
import {
  Header,
  HeaderWrapper,
  Logo
} from "../Header/styles.js";
import { toast } from "react-toastify";

export default ({ setActived, cart_token }) => {
  var type;
  var color;

  if (cookie.get('souv_type') == 'room') {
    type = 'Entregue no quarto do hotel';
    color = "#df7655";
  } else if (cookie.get('souv_type') == 'store') {
    type = 'Retirar em nosso Pátio Goods Br';
    color = "#0c6f7b";
  } else if (cookie.get('souv_type') == 'expo') {
    type = 'Retirar do expositor';
    color = "#249fac";
  }
  async function setActive() {
    return setActived(false);
  }
  const [stock, setStock] = useState(true);

  function handleSubmit() {
    setActive();

  }

  return (

    <Form style={{ top: '10%', textAlign: 'left', height: '60%', background: 'black' }}>
      <div style={{ margin: '30% auto' }}>
        <h1 style={{ color: 'white', marginBottom: '15px'}}>IMPORTANTE</h1>
        <SouvenirCheck>
          <p style={{ color: "white", fontWeight: "bold" }}>A modalidade de entrega que você optou é:</p>
          <h3 style={{ textTransform: "uppercase", color: color, fontWeight: "bold" }}>{type}</h3>
        </SouvenirCheck>
        <FormButton style={{ background: "#00707d", color: "white", fontWeight: "bold" }} onClick={handleSubmit} type="submit">OK</FormButton>
      </div>
    </Form>
  );
};

